import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Users, ChevronRight } from 'lucide-react';
import api from '../../services/api';

export default function Attendance() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadSessions(); }, []);

  const loadSessions = async () => {
    try {
      const res = await api.get('/admin/attendance/sessions').catch(() => ({ data: { sessions: [] } }));
      if (res.data.success) setSessions(res.data.sessions || []);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div></div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">Attendance Overview</h1>
        <p className="text-gray-500">View all attendance sessions across grades</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="p-4 border-b border-gray-100">
          <h3 className="font-semibold text-gray-800">Attendance Sessions ({sessions.length})</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Date</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Subject</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Grade</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Marked By</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {sessions.map((session) => (
                <tr 
                  key={session.session_id} 
                  onClick={() => navigate(`/admin/attendance/${session.session_id}`)}
                  className="hover:bg-indigo-50 cursor-pointer transition-colors"
                >
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-indigo-100 rounded-lg">
                        <Calendar className="w-4 h-4 text-indigo-600" />
                      </div>
                      <span className="font-medium text-gray-800">{new Date(session.session_date).toLocaleDateString()}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{session.subject_name}</td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-1 bg-blue-50 text-blue-600 rounded-full text-xs">{session.grade_name}</span>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{session.marked_by_name}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-600">{session.session_description || '-'}</span>
                      <ChevronRight className="w-4 h-4 text-gray-400" />
                    </div>
                  </td>
                </tr>
              ))}
              {sessions.length === 0 && (
                <tr><td colSpan="5" className="px-4 py-8 text-center text-gray-400">No attendance sessions recorded yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
